let activeDriver = null;

export function setActiveDriver(instance) {
    activeDriver = instance || null;
}

export function getActiveDriver() {
    return activeDriver;
}

export function clearActiveDriver() {
    activeDriver = null;
}

